export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "Altitude [m]": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wysokość [m]"])}
      }
    }
  })
}
